import { render, staticRenderFns } from "./navigator-class-setup.vue?vue&type=template&id=4081d7f6&"
import script from "./navigator-class-setup.ts?vue&type=script&lang=ts&"
export * from "./navigator-class-setup.ts?vue&type=script&lang=ts&"
import style0 from "./navigator-class-setup.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports